import React, { useEffect, useState } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
// import Tab from "react-bootstrap/Tab";
// import Tabs from "react-bootstrap/Tabs";
// import VouchersDashboard from "../VouchersDashboard/VouchersDashboard";
import ManageVouchers from "../ManageVouchers/ManageVouchers";
// import CouponsDashboard from "../CouponsDashboard/CouponsDashboard";
// import ManageCoupons from "../ManageCoupons/ManageCoupons";
// import UserManagement from "../UserManagement/UserManagement";
import { Link, NavLink } from "react-router-dom";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";

const MyAccManageVouchers = () => {
  const [currentTab, setcurrentTab] = useState("");

  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "manage-vouchers") {
      setcurrentTab("managevouchers");
    }
  }, []);

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/dashboard"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">My Account</p>
          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink
                to={"/my-account/vouchers-dashboard"}
                className={"tabs_li"}
              >
                Vouchers Dashboard
              </NavLink>
              <NavLink
                to={""}
                className={
                  currentTab === "managevouchers" ? " activeTab" : "tabs_li"
                }
              >
                Manage Vouchers
              </NavLink>
              <NavLink
                to={"/my-account/coupons-dashboard"}
                className={"tabs_li"}
              >
                Coupons Dashboard
              </NavLink>
              <NavLink to={"/my-account/manage-coupons"} className={"tabs_li"}>
                Manage Coupons
              </NavLink>
            </div>

            <div className="mt-3">
              <ManageVouchers />
            </div>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default MyAccManageVouchers;
